import { Injectable, inject } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { PropertyInformationModel } from '../../cmg-1003/models';
import { SessionStore } from '../../core/state';
import { iStoreActions } from '../core/store-actions.interface';

function createInitialState(): PropertyInformationModel {
  return <PropertyInformationModel>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-1003-property-store', idKey: 'fileDataId' })
export class Cmg1003PropertyStore extends Store<PropertyInformationModel> implements iStoreActions<PropertyInformationModel> {
  private readonly _sessionStore = inject(SessionStore);

  private _initValue: PropertyInformationModel = null;
  constructor() {
    super(createInitialState());
  }

  override akitaPreUpdate(_: Readonly<PropertyInformationModel>, nextState: Readonly<PropertyInformationModel>): PropertyInformationModel {
    this._sessionStore.update({ lastUpdatedDateTime: Date.now() });
    return nextState;
  }

  preInitialize(): void {
    this._initValue = JSON.parse(JSON.stringify(this.getValue()));
  }

  get initialValue() {
    return this._initValue;
  }
}
